import ChekinAPI from '../ChekinAPI';
import {LocalStorage, MemoryStorage} from '@guestapp/core';
import {GUEST_TOKEN_STORAGE_KEY, TOKEN_STORAGE_KEY} from './constants';

abstract class TokenStorageHandler {
  protected static key: string;

  static getToken(): string | null {
    const isChekinConsumer = ChekinAPI.initParams?.isChekinConsumer;

    if (!isChekinConsumer) {
      return MemoryStorage.get<string>(this.key);
    }

    try {
      const storageToken = LocalStorage.get<string>(this.key);
      return storageToken ?? null;
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  static persistToken(token: string | null = ''): void {
    const isChekinConsumer = ChekinAPI.initParams?.isChekinConsumer;

    if (isChekinConsumer) {
      LocalStorage.set(this.key, token);
    } else {
      MemoryStorage.set(this.key, token);
    }
  }

  static removeToken(): void {
    const isChekinConsumer = ChekinAPI.initParams?.isChekinConsumer;

    if (isChekinConsumer) {
      LocalStorage.remove(this.key);
    } else {
      MemoryStorage.remove(this.key);
    }
  }

  static hasToken(): boolean {
    return Boolean(this.getToken());
  }
}

class MainTokenStorageHandler extends TokenStorageHandler {
  protected static key = TOKEN_STORAGE_KEY;
}

class GuestTokenStorageHandler extends TokenStorageHandler {
  protected static key = GUEST_TOKEN_STORAGE_KEY;
}

export {MainTokenStorageHandler, GuestTokenStorageHandler};
